export default "__VITE_ASSET__BsD96L6b__"